import {Module} from 'vuex';

/**
 * @type {Module}
 */
const rewards = {
    namespaced: true,
    state: {
        points: 0,
        applied_points: 0,
        is_shipped_for_points: false,
        error_message: null,
        bonus_total: 0
    },
    mutations: {
        setPoints: (s, v) => s.points = v,
        setAppliedPoints: (s, v) => s.applied_points = v,
        setIsShippedForPoints: (s, v) => s.is_shipped_for_points = v,
        setErrorMessage: (s, v) => s.error_message = v,
        setBonusTotal: (s, v) => s.bonus_total = v,
    }
};

export default rewards;
